<ion-row *ngIf="dateDisplay?.date" class=" status-{{ dateDisplay?.state }}">
  <ion-col size="12" class="label">
    <p id="AT_date_label" class="small">{{ dateDisplay?.label | translate: dateDisplay?.internationalizationType | uppercase }}</p>
  </ion-col>
  <ion-col size="12" class="date">
    <ion-icon [name]="dateDisplay?.icon"></ion-icon>
    <span id="AT_date_value" class="small">{{ dateDisplay?.date | date: (dateDisplay?.format ? dateDisplay?.format : 'dd/MM/yyyy HH:mm') }}</span>
  </ion-col>
</ion-row>
